import { Routes } from '@angular/router';

import { VANILLA_LAZY_ROUTES } from '@frontend/loaders/routes';
import { ClientConfigProductName } from '@frontend/vanilla/core';

import { LEGACY_PORTAL_ROUTES } from './legacy-portal.routes';
import { MY_ACCOUNT_ROUTES } from './my-account.routes';

export const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./home/home-page-routes').then((m) => m.homePageRoutes),
    },
    {
        path: '{culture}',
        children: [
            ...VANILLA_LAZY_ROUTES,
            ...LEGACY_PORTAL_ROUTES,
            {
                path: 'p',
                loadChildren: () => import('@frontend/vanilla/features/public-page').then((m) => m.ROUTES),
                data: {
                    publicPageRoot: 'MobilePortal-v1.0/PublicPages/',
                    product: ClientConfigProductName.PORTAL,
                },
            },
            {
                path: '',
                loadChildren: () => import(/* webpackChunkName: "pt-home-page-module" */ './home/home-page-routes').then((m) => m.homePageRoutes),
            },
            {
                path: 'mobileportal',
                children: [...MY_ACCOUNT_ROUTES],
            },
        ],
    },
    {
        path: '**',
        loadChildren: () => import('@frontend/vanilla/features/not-found').then((m) => m.ROUTES),
    },
];
